import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15, default as _styled16, default as _styled17, default as _styled18, default as _styled19, default as _styled20, default as _styled21, default as _styled22, default as _styled23, default as _styled24, default as _styled25, default as _styled26 } from "styled-components";
import React from "react";
import { useRouter } from "next/router";
import { clearRouterPath } from "~/features/app/utils";
import { type Mode } from "~/features/ui/get-theme-style";
import { Button } from "~/features/ui/button";
import { Pattern } from "~/features/app/pattern";
import { ReserveGearDialog } from "~/features/reserve-gear-dialog";
import { RESERVE_GEAR_MODAL_ID } from "~/features/reserve-gear-dialog/modal";
import ArrowRight from "~/public/icons/arrow-right.svg";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
type SpecRow = {
  _key?: string;
  label?: string;
  value?: string;
};
type AccordionEntry = {
  title: string;
  body: React.ReactNode;
};
export type ShopProductBlockViewProps = {
  anchor?: {
    id?: string | null;
    name?: string | null;
  } | null;
  hasTopDivider?: boolean | null;
  mode?: string | null;
  theme?: string | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  productSlug?: string | null;
  title?: string | null;
  price?: string | null;
  description?: React.ReactNode;
  image?: React.ReactNode;
  sizeOptions?: string[] | null;
  specs?: SpecRow[] | null;
  accordions?: AccordionEntry[];
  limitNote?: string | null;
  soldOut?: boolean | null;
};
function SizeSelector({
  options,
  value,
  onChange
}: {
  options: string[];
  value?: string;
  onChange: (size: string) => void;
}) {
  const isLocked = options.length <= 1;
  return <_StyledDiv role={isLocked ? undefined : "radiogroup"} aria-label="Size" $_css={[{
    "display": "flex",
    "flexWrap": "wrap",
    "gap": "0.8rem"
  }]}>
      {options.map(option => {
      const selected = option === value;
      return <_StyledButton key={option} type="button"
      // A single option ("One Size") is a locked, non-interactive chip.
      disabled={isLocked} aria-pressed={selected} onClick={isLocked ? undefined : () => onChange(option)} $_css2={[{
        "minWidth": "4.8rem",
        "borderRadius": "2px",
        "borderWidth": "1px",
        "paddingLeft": "1.6rem",
        "paddingRight": "1.6rem",
        "paddingTop": "0.8rem",
        "paddingBottom": "0.8rem",
        "textAlign": "center",
        "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
        "transitionDuration": "250ms",
        "transitionTimingFunction": "ease-in-out"
      }, {
        "fontSize": "1.4rem",
        "lineHeight": "1.1",
        "letterSpacing": "0.028000000000000004rem",
        "fontWeight": "400",
        "@media (min-width: 1024px)": {
          "fontSize": "1.6rem",
          "lineHeight": "1.1",
          "letterSpacing": "0.016rem",
          "fontWeight": "400"
        }
      }, selected ? {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(75 46 248 / var(--tw-border-opacity))",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
        "--tw-text-opacity": "1",
        "color": "rgb(255 255 255 / var(--tw-text-opacity))"
      } : {
        "borderColor": "var(--stroke-primary)",
        "color": "var(--text-primary)",
        "&:hover": {
          "borderColor": "var(--fg-primary)"
        }
      }, isLocked && {
        "cursor": "default"
      }]}>
            {option}
          </_StyledButton>;
    })}
    </_StyledDiv>;
}
function Accordion({
  entries
}: {
  entries: AccordionEntry[];
}) {
  const [openIndex, setOpenIndex] = React.useState<number | null>(null);
  return <_StyledDiv2 $_css3={[{
    "display": "flex",
    "flexDirection": "column"
  }]}>
      {entries.map((entry, index) => {
      const isOpen = openIndex === index;
      return <_StyledDiv3 key={entry.title} $_css4={[{
        "borderTopWidth": "1px",
        "borderColor": "var(--stroke-primary)"
      }]}>
            <_StyledButton2 type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} $_css5={[{
          "display": "flex",
          "width": "100%",
          "alignItems": "center",
          "justifyContent": "space-between",
          "gap": "1.6rem",
          "paddingTop": "1.6rem",
          "paddingBottom": "1.6rem",
          "textAlign": "left",
          "color": "var(--text-primary)"
        }, {
          "fontSize": "2rem",
          "lineHeight": "1.3",
          "letterSpacing": "0.02rem",
          "fontWeight": "400",
          "@media (min-width: 1024px)": {
            "fontSize": "2.4rem",
            "lineHeight": "1.3",
            "letterSpacing": "0.024rem",
            "fontWeight": "400"
          }
        }]}>
              <span>{entry.title}</span>
              <_StyledSpan aria-hidden $_css6={[{
            "fontSize": "3.2rem",
            "lineHeight": "1",
            "letterSpacing": "0.032rem",
            "fontWeight": "400"
          }]}>
                {isOpen ? "−" : "+"}
              </_StyledSpan>
            </_StyledButton2>
            {isOpen && <_StyledDiv4 $_css7={[{
          "paddingBottom": "1.6rem",
          "fontSize": "1.4rem",
          "lineHeight": "1.5",
          "letterSpacing": "0.014000000000000002rem",
          "fontWeight": "400",
          "color": "var(--text-primary)",
          "@media (min-width: 1024px)": {
            "fontSize": "1.4rem",
            "lineHeight": "1.5",
            "letterSpacing": "0.014000000000000002rem",
            "fontWeight": "400"
          }
        }]}>
                {entry.body}
              </_StyledDiv4>}
          </_StyledDiv3>;
    })}
    </_StyledDiv2>;
}

/**
 * Product detail hero: image on the left, product info + size selector +
 * "Reserve Gear" button + Details/Materials accordions on the right. Light/dark
 * follows the section's `data-theme`.
 */
export function ShopProductBlockView({
  anchor,
  hasTopDivider = true,
  mode = "light",
  theme = "white",
  sectionProps,
  productSlug,
  title,
  price,
  description,
  image,
  sizeOptions,
  specs,
  accordions = [],
  limitNote,
  soldOut = false
}: ShopProductBlockViewProps) {
  const router = useRouter();
  const options = sizeOptions?.map(option => option.trim()).filter(Boolean) ?? [];
  const [selectedSize, setSelectedSize] = React.useState<string | undefined>(options[0]);
  React.useEffect(() => {
    setSelectedSize(sizeOptions?.map(option => option.trim()).filter(Boolean)[0]);
  }, [productSlug, sizeOptions]);
  if (!title && !image) {
    return null;
  }
  const canReserve = !soldOut && Boolean(productSlug && selectedSize && options.includes(selectedSize));
  const openReserveModal = () => {
    if (!canReserve) {
      return;
    }
    router.push({
      pathname: clearRouterPath(router.asPath),
      query: {
        ...router.query,
        modal: RESERVE_GEAR_MODAL_ID,
        ...(productSlug ? {
          product: productSlug
        } : {}),
        ...(selectedSize ? {
          size: selectedSize
        } : {})
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
  };
  return <_StyledSection {...sectionProps} data-theme={mode as Mode} id={anchor?.id || undefined} data-anchor-name={anchor?.name || undefined} $_css8={[{
    "position": "relative",
    "backgroundColor": "var(--bg-primary)",
    "color": "var(--text-primary)"
  }, hasTopDivider && {
    "borderTopWidth": "1px",
    "borderColor": "var(--stroke-primary)"
  }, theme === "grey" && {
    "backgroundColor": "var(--bg-tertiary)"
  }]}>
      <_StyledDiv5 $_css9={[{
      "display": "flex",
      "flexDirection": "column",
      "@media (min-width: 1024px)": {
        "flexDirection": "row"
      }
    }]}>
        {/* Image on a dark dotted panel, centered and contained. */}
        <_StyledDiv6 $_css10={[{
        "position": "relative",
        "display": "flex",
        "width": "100%",
        "alignItems": "center",
        "justifyContent": "center",
        "backgroundColor": "var(--bg-secondary)",
        "paddingLeft": "var(--spacing-lg)",
        "paddingRight": "var(--spacing-lg)",
        "paddingTop": "var(--spacing-2xl)",
        "paddingBottom": "var(--spacing-2xl)",
        "@media (min-width: 1024px)": {
          "minHeight": "70rem",
          "width": "60%",
          "padding": "var(--spacing-3xl)"
        }
      }]}>
          <Pattern pattern="dotted" />
          {image && <_StyledDiv7 $_css11={[{
          "position": "relative",
          "zIndex": "10",
          "width": "100%",
          "maxWidth": "48rem"
        }]}>{image}</_StyledDiv7>}
        </_StyledDiv6>

        {/* Info */}
        <_StyledDiv8 $_css12={[{
        "display": "flex",
        "width": "100%",
        "flexDirection": "column",
        "gap": "var(--spacing-xl)",
        "paddingLeft": "var(--spacing-lg)",
        "paddingRight": "var(--spacing-lg)",
        "paddingTop": "var(--spacing-2xl)",
        "paddingBottom": "var(--spacing-2xl)",
        "@media (min-width: 1024px)": {
          "width": "40%",
          "paddingLeft": "var(--spacing-3xl)",
          "paddingRight": "var(--spacing-3xl)",
          "paddingTop": "var(--spacing-4xl)",
          "paddingBottom": "var(--spacing-4xl)"
        }
      }]}>
          <_StyledDiv9 $_css13={[{
          "display": "flex",
          "flexDirection": "column",
          "gap": "var(--spacing-md)"
        }]}>
            {title && <_StyledH $_css14={[{
            "fontSize": "2.2rem",
            "lineHeight": "1.2",
            "fontWeight": "400",
            "color": "var(--text-primary)",
            "@media (min-width: 1024px)": {
              "fontSize": "3.2rem",
              "lineHeight": "1.2",
              "letterSpacing": "0.032rem",
              "fontWeight": "400"
            }
          }]}>{title}</_StyledH>}
            {price && <_StyledP $_css15={[{
            "fontSize": "2rem",
            "lineHeight": "1.3",
            "letterSpacing": "0.02rem",
            "fontWeight": "400",
            "color": "var(--text-primary)",
            "@media (min-width: 1024px)": {
              "fontSize": "2.4rem",
              "lineHeight": "1.3",
              "letterSpacing": "0.024rem",
              "fontWeight": "400"
            }
          }]}>{price}</_StyledP>}
            {description && <_StyledDiv10 $_css16={[{
            "fontSize": "1.4rem",
            "lineHeight": "1.5",
            "letterSpacing": "0.014000000000000002rem",
            "fontWeight": "400",
            "color": "var(--text-primary)",
            "opacity": "0.8",
            "@media (min-width: 1024px)": {
              "fontSize": "1.4rem",
              "lineHeight": "1.5",
              "letterSpacing": "0.014000000000000002rem",
              "fontWeight": "400"
            }
          }]}>
                {description}
              </_StyledDiv10>}
          </_StyledDiv9>

          {options.length > 0 && <_StyledDiv11 $_css17={[{
          "display": "flex",
          "flexDirection": "column",
          "gap": "0.8rem"
        }]}>
              <_StyledSpan2 $_css18={[{
            "fontSize": "1.2rem",
            "lineHeight": "1.1",
            "letterSpacing": "0.024rem",
            "fontWeight": "400",
            "color": "var(--text-primary)",
            "opacity": "0.6",
            "@media (min-width: 1024px)": {
              "fontSize": "1.4rem",
              "lineHeight": "1.1",
              "letterSpacing": "0.028000000000000004rem",
              "fontWeight": "400"
            }
          }]}>
                Size
              </_StyledSpan2>
              <SizeSelector options={options} value={selectedSize} onChange={setSelectedSize} />
            </_StyledDiv11>}

          {specs && specs.length > 0 && <_StyledDl $_css19={[{
          "display": "flex",
          "flexDirection": "column"
        }]}>
              {specs.map((spec, index) => <_StyledDiv12 key={spec._key || index} $_css20={[{
            "display": "flex",
            "alignItems": "center",
            "justifyContent": "space-between",
            "gap": "1.6rem",
            "borderTopWidth": "1px",
            "borderColor": "var(--stroke-primary)",
            "paddingTop": "1.2rem",
            "paddingBottom": "1.2rem"
          }, {
            "fontSize": "1.4rem",
            "lineHeight": "1.5",
            "letterSpacing": "0.014000000000000002rem",
            "fontWeight": "400",
            "@media (min-width: 1024px)": {
              "fontSize": "1.4rem",
              "lineHeight": "1.5",
              "letterSpacing": "0.014000000000000002rem",
              "fontWeight": "400"
            }
          }]}>
                  <_StyledDt $_css21={[{
              "color": "var(--text-primary)",
              "opacity": "0.6"
            }]}>{spec.label}</_StyledDt>
                  <_StyledDd $_css22={[{
              "color": "var(--text-primary)"
            }]}>{spec.value}</_StyledDd>
                </_StyledDiv12>)}
            </_StyledDl>}

          <_StyledDiv13 $_css23={[{
          "display": "flex",
          "flexDirection": "column",
          "gap": "0.8rem"
        }]}>
            <Button variant="primary" fullWidth icon={ArrowRight} disabled={!canReserve} onClick={openReserveModal}>
              {soldOut ? "Sold Out" : "Reserve Gear"}
            </Button>
            {limitNote && <_StyledP2 $_css24={[{
            "fontSize": "1.2rem",
            "lineHeight": "1.1",
            "letterSpacing": "0.024rem",
            "fontWeight": "400",
            "color": "var(--text-primary)",
            "opacity": "0.6",
            "@media (min-width: 1024px)": {
              "fontSize": "1.4rem",
              "lineHeight": "1.1",
              "letterSpacing": "0.028000000000000004rem",
              "fontWeight": "400"
            }
          }]}>
                {limitNote}
              </_StyledP2>}
          </_StyledDiv13>

          {accordions.length > 0 && <_StyledDiv14 $_css25={[{
          "display": "flex",
          "flexDirection": "column",
          "gap": "0.8rem"
        }]}>
              <_StyledSpan3 $_css26={[{
            "fontSize": "1.2rem",
            "lineHeight": "1.1",
            "letterSpacing": "0.024rem",
            "fontWeight": "400",
            "color": "var(--text-primary)",
            "opacity": "0.6",
            "@media (min-width: 1024px)": {
              "fontSize": "1.4rem",
              "lineHeight": "1.1",
              "letterSpacing": "0.028000000000000004rem",
              "fontWeight": "400"
            }
          }]}>
                Others
              </_StyledSpan3>
              <Accordion entries={accordions} />
            </_StyledDiv14>}
        </_StyledDiv8>
      </_StyledDiv5>

      {canReserve && <ReserveGearDialog key={productSlug} productSlug={productSlug} productImage={image} />}
    </_StyledSection>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-il618w-0"
})`${p => p.$_css}`;
var _StyledButton = _styled2("button").withConfig({
  componentId: "sc-sf-il618w-1"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-il618w-2"
})`${p => p.$_css3}`;
var _StyledDiv3 = _styled4("div").withConfig({
  componentId: "sc-sf-il618w-3"
})`${p => p.$_css4}`;
var _StyledButton2 = _styled5("button").withConfig({
  componentId: "sc-sf-il618w-4"
})`${p => p.$_css5}`;
var _StyledSpan = _styled6("span").withConfig({
  componentId: "sc-sf-il618w-5"
})`${p => p.$_css6}`;
var _StyledDiv4 = _styled7("div").withConfig({
  componentId: "sc-sf-il618w-6"
})`${p => p.$_css7}`;
var _StyledSection = _styled8("section").withConfig({
  componentId: "sc-sf-il618w-7"
})`${p => p.$_css8}`;
var _StyledDiv5 = _styled9("div").withConfig({
  componentId: "sc-sf-il618w-8"
})`${p => p.$_css9}`;
var _StyledDiv6 = _styled10("div").withConfig({
  componentId: "sc-sf-il618w-9"
})`${p => p.$_css10}`;
var _StyledDiv7 = _styled11("div").withConfig({
  componentId: "sc-sf-il618w-10"
})`${p => p.$_css11}`;
var _StyledDiv8 = _styled12("div").withConfig({
  componentId: "sc-sf-il618w-11"
})`${p => p.$_css12}`;
var _StyledDiv9 = _styled13("div").withConfig({
  componentId: "sc-sf-il618w-12"
})`${p => p.$_css13}`;
var _StyledH = _styled14("h1").withConfig({
  componentId: "sc-sf-il618w-13"
})`${p => p.$_css14}`;
var _StyledP = _styled15("p").withConfig({
  componentId: "sc-sf-il618w-14"
})`${p => p.$_css15}`;
var _StyledDiv10 = _styled16("div").withConfig({
  componentId: "sc-sf-il618w-15"
})`${p => p.$_css16}`;
var _StyledDiv11 = _styled17("div").withConfig({
  componentId: "sc-sf-il618w-16"
})`${p => p.$_css17}`;
var _StyledSpan2 = _styled18("span").withConfig({
  componentId: "sc-sf-il618w-17"
})`${p => p.$_css18}`;
var _StyledDl = _styled19("dl").withConfig({
  componentId: "sc-sf-il618w-18"
})`${p => p.$_css19}`;
var _StyledDiv12 = _styled20("div").withConfig({
  componentId: "sc-sf-il618w-19"
})`${p => p.$_css20}`;
var _StyledDt = _styled21("dt").withConfig({
  componentId: "sc-sf-il618w-20"
})`${p => p.$_css21}`;
var _StyledDd = _styled22("dd").withConfig({
  componentId: "sc-sf-il618w-21"
})`${p => p.$_css22}`;
var _StyledDiv13 = _styled23("div").withConfig({
  componentId: "sc-sf-il618w-22"
})`${p => p.$_css23}`;
var _StyledP2 = _styled24("p").withConfig({
  componentId: "sc-sf-il618w-23"
})`${p => p.$_css24}`;
var _StyledDiv14 = _styled25("div").withConfig({
  componentId: "sc-sf-il618w-24"
})`${p => p.$_css25}`;
var _StyledSpan3 = /*#__PURE__*/_styled26("span").withConfig({
  displayName: "shop-product___StyledSpan3",
  componentId: "sc-ennzn3-0"
})(["", ""], p => p.$_css26);